/**
 * Retrieves a color from the predefined list of colors in a cyclic manner.
 * @returns {string} The next color in the sequence.
 */
export function getColor() {
    return colors[i++ % colors.length];
}

/**
 * Array of predefined colors.
 * @type {string[]}
 */
const colors = [
    '#8664C6', // Purple
    '#BCAAE0', // Light Purple
    '#1CA1C1', // Blue
    '#5ABBD2', // Light Blue
    '#FDBF4C', // Yellow
    '#F8643F', // Red
];

let i = 0; // Index for cycling through colors

// FILE DOCUMENTED
